// utils/app.js
export let app = null
export function setApp(instance) {
  app = instance
}
